import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tip } from '@/views/visual/dataScreen/js/config';
import { funEval } from '@/views/visual/dataScreen/js/utils/utils';
import MonacoEditor from '@/views/visual/dataScreen/components/editor';
export default {
  components: {
    MonacoEditor: MonacoEditor
  },
  data: function data() {
    return {
      code: '',
      tip: ''
    };
  },
  props: {
    visible: Boolean,
    type: String,
    value: [String, Object, Array]
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (this.validatenull(val)) {
          if (['dataFormatter', 'stylesFormatter'].includes(this.type) && this.validatenull(val)) {
            this.code = "function(data,params,refs){\n    return {}\n}";
          } else if (['query', 'header', 'dataQuery', 'dataHeader'].includes(this.type) && this.validatenull(val)) {
            this.code = "function(data){\n    return {}\n}";
          } else if (['echartFormatter'].includes(this.type) && this.validatenull(val)) {
            this.code = "function(params){\n    alert(params)\n}";
          } else if (['clickFormatter'].includes(this.type) && this.validatenull(val)) {
            this.code = "function(params,refs){\n    console.log(params,refs)\n}";
          } else if (['labelFormatter', 'formatter'].includes(this.type) && this.validatenull(val)) {
            this.code = "function(name,data){\n    console.log(name,data)\n    return {}\n}";
          }
        } else {
          this.code = val;
        }
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    this.tip = tip;
  },
  methods: {
    handleClose: function handleClose() {
      this.setVisible(false);
    },
    submit: function submit() {
      var value = this.code;

      try {
        funEval(value);
        if (['data'].includes(this.type)) value = funEval(value);
        this.$emit('submit', value);
        this.setVisible(false);
      } catch (error) {
        console.log(error);
        this.$message.error('数据格式有误');
      }
    },
    setVisible: function setVisible(val) {
      this.$emit('update:visible', val);
    }
  }
};